import { Flame, Lock, MoreHorizontal, Shuffle } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";


export const MealRow = ({ item, onOpen, onSwap, onToggleLock }) => {
  return (
    <div className="meal-row-hover flex items-center gap-3 rounded-[26px] border border-stone-200/80 bg-white/85 p-3" data-testid={`planner-meal-row-${item.id}`}>
      <button
        type="button"
        className="flex flex-1 items-center gap-3 text-left"
        onClick={() => onOpen(item)}
        data-testid={`planner-meal-open-${item.id}`}
      >
        <img
          src={item.recipe.thumbnail_url}
          alt={item.recipe.title}
          className="h-16 w-16 rounded-[20px] object-cover"
          data-testid={`planner-meal-image-${item.id}`}
        />
        <div className="min-w-0 flex-1">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-emerald-700" data-testid={`planner-meal-slot-${item.id}`}>
            {item.slot_label}
          </p>
          <h3 className="mt-1 line-clamp-2 text-sm font-semibold text-stone-900" data-testid={`planner-meal-title-${item.id}`}>
            {item.recipe.title}
          </h3>
          <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-stone-500">
            <span className="inline-flex items-center gap-1 rounded-full bg-orange-100 px-2 py-1 text-orange-700" data-testid={`planner-meal-kcal-${item.id}`}>
              <Flame className="h-3 w-3" />
              {item.recipe.kcal_per_serving} kcal
            </span>
            <span className="rounded-full bg-emerald-100 px-2 py-1 text-emerald-800" data-testid={`planner-meal-carbs-${item.id}`}>
              {item.recipe.carbs_per_serving} g carbs
            </span>
            <span className="rounded-full bg-stone-100 px-2 py-1 text-stone-700" data-testid={`planner-meal-season-${item.id}`}>
              {item.recipe.season_tags[0]}
            </span>
            {item.is_cooked ? (
              <span className="rounded-full bg-emerald-100 px-2 py-1 text-emerald-800" data-testid={`planner-meal-cooked-state-${item.id}`}>
                Gekookt
              </span>
            ) : null}
            {item.is_locked ? (
              <span className="rounded-full bg-emerald-100 px-2 py-1 text-emerald-800" data-testid={`planner-meal-lock-state-${item.id}`}>
                Gelockt
              </span>
            ) : null}
            {item.source_label ? (
              <span className="rounded-full bg-amber-100 px-2 py-1 text-amber-800" data-testid={`planner-meal-source-label-${item.id}`}>
                {item.source_label}
              </span>
            ) : null}
          </div>
          {item.leftover_suggestion && item.source_type !== "leftover" ? (
            <p className="mt-2 text-xs text-stone-500" data-testid={`planner-meal-leftover-suggestion-${item.id}`}>
              Tip: {item.leftover_suggestion.recipe_title} ligt klaar · {item.leftover_suggestion.reason_label.toLowerCase()}
            </p>
          ) : null}
          {item.carb_guidance_label ? (
            <p className="mt-2 text-xs text-stone-500" data-testid={`planner-meal-carb-guidance-${item.id}`}>
              {item.carb_guidance_label}
            </p>
          ) : null}
          {item.explanation_chips?.length ? (
            <div className="mt-2 flex flex-wrap gap-2" data-testid={`planner-meal-explanation-chips-${item.id}`}>
              {item.explanation_chips.map((chip, chipIndex) => (
                <span key={`${item.id}-${chip}`} className="rounded-full bg-stone-100 px-2.5 py-1 text-[11px] font-medium text-stone-700" data-testid={`planner-meal-explanation-chip-${item.id}-${chipIndex}`}>
                  {chip}
                </span>
              ))}
            </div>
          ) : null}
        </div>
      </button>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" data-testid={`planner-meal-menu-trigger-${item.id}`}>
            <MoreHorizontal className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" data-testid={`planner-meal-menu-${item.id}`}>
          <DropdownMenuItem onClick={() => onSwap(item.id)} data-testid={`planner-meal-swap-${item.id}`}>
            <Shuffle className="mr-2 h-4 w-4" />
            Wissel maaltijd
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onToggleLock(item.id, !item.is_locked)} data-testid={`planner-meal-lock-toggle-${item.id}`}>
            <Lock className="mr-2 h-4 w-4" />
            {item.is_locked ? "Ontgrendel" : "Lock maaltijd"}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};